import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Award, Star } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function InstructorsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-235">
      <div className="max-w-5xl mx-auto" data-id="element-236">
        <div className="text-center mb-16" data-id="element-237">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-4" data-id="element-238">
            Our Instructors
          </h2>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full" data-id="element-239"></div>
        </div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-16" data-id="element-240">
          {/* Instructor Isaak */}
          <motion.div variants={fadeIn} className="bg-white rounded-2xl shadow-lg border-2 border-[#a3d977]/20 overflow-hidden" data-id="element-241">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-242">
              <div className="h-64 md:h-auto bg-gray-200 relative" data-id="element-243">
                <img src="https://cdn.magicpatterns.com/uploads/hWo21ntFNFekEExeYkJobN/INSTRUCTOR_ISAAK_WHITWORTH.png" alt="Instructor Isaak Whitworth" className="w-full h-full object-cover" data-id="element-244" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-245">
                <h3 className="text-2xl font-bold text-[#0f1f3d] mb-4" data-id="element-246">
                  Instructor Isaak Whitworth
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-247">
                  Taekwondo has been a part of Instructor Isaak's life from a
                  very young age. The dojang is a second home for him. While
                  Instructor Isaak teaches many of the classes he is also one of
                  the highest ranking students. Instructor Isaak has also
                  competed and been a National Team Member with USAT. He is an
                  all around athlete and excellent instructor.
                </p>
                <div className="flex items-center gap-2 text-[#dc2626] font-semibold text-sm" data-id="element-248">
                  <Award className="w-4 h-4" data-id="element-249" />
                  <span data-id="element-250">National Team Member</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Instructor Sung Ho */}
          <motion.div variants={fadeIn} className="bg-white rounded-2xl shadow-lg border-2 border-[#a3d977]/20 overflow-hidden" data-id="element-251">
            <div className="grid grid-cols-1 md:grid-cols-2 md:grid-flow-dense" data-id="element-252">
              <div className="p-8 md:p-12 flex flex-col justify-center order-2 md:order-1" data-id="element-253">
                <h3 className="text-2xl font-bold text-[#0f1f3d] mb-4" data-id="element-254">
                  Instructor Sung Ho Park
                </h3>
                <p className="text-gray-600 leading-relaxed italic mb-4" data-id="element-255">
                  "A wise person once said 'Do not think about the result, but
                  always think in between.' ... Taekwondo has taught me respect
                  and given me confidence."
                </p>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-256">
                  I have come a long way in the last ten years and I am so proud
                  of how far I have come through all of the training, the blood,
                  sweat and tears at times, my coaches and teammates have shaped
                  me and who I am as an instructor and athlete. I always want to
                  give back to my students as I am a role model for many of
                  them.
                </p>
                <div className="flex items-center gap-2 text-[#dc2626] font-semibold text-sm" data-id="element-257">
                  <Star className="w-4 h-4" data-id="element-258" />
                  <span data-id="element-259">Role Model & Mentor</span>
                </div>
              </div>
              <div className="h-64 md:h-auto bg-gray-200 relative order-1 md:order-2" data-id="element-260">
                <img src="https://cdn.magicpatterns.com/uploads/qMGwLKReoAPQb76H5erx8N/INSTRUCTOR_SUNG_HO_PARK.png" alt="Instructor Sung Ho Park" className="w-full h-full object-cover" data-id="element-261" />
              </div>
            </div>
          </motion.div>

          {/* Instructor Ellie */}
          <motion.div variants={fadeIn} className="bg-white rounded-2xl shadow-lg border-2 border-[#a3d977]/20 overflow-hidden" data-id="element-262">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-263">
              <div className="h-64 md:h-auto bg-gray-200 relative" data-id="element-264">
                <img src="https://cdn.magicpatterns.com/uploads/cUwfwfkA9ZMr14VM5GnGqR/INSTRUCTOR_ELLIE_WHITWORTH.png" alt="Instructor Ellie Whitworth" className="w-full h-full object-cover" data-id="element-265" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-266">
                <h3 className="text-2xl font-bold text-[#0f1f3d] mb-4" data-id="element-267">
                  Instructor Ellie Whitworth
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6" data-id="element-268">
                  The last 12 years of my life I have spent in the dojang with
                  my family. Taekwondo has changed my life in that it has given
                  me confidence and it has provided me an opportunity to make
                  goals and work diligently toward them. Even though it is hard,
                  I love it because it challenges me, and I am a better person.
                  I have more perseverance and I am a better athlete because of
                  it.
                </p>
                <div className="flex items-center gap-2 text-[#dc2626] font-semibold text-sm" data-id="element-269">
                  <Award className="w-4 h-4" data-id="element-270" />
                  <span data-id="element-271">12 Years Experience</span>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}